import styled from 'styled-components'

export const SList = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;
`

export const SLi = styled.li`
  font-size: 16px;
  line-height: 24px;
  margin-bottom: 12px;
  display: flex;
  &:before {
    content: '';
    display: block;
    flex-shrink: 0;
    flex-grow: 0;
    margin-top: 8px;
    margin-right: 12px;
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: ${({ theme }) => theme.colors.green};
  }
`